import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';  
import { NzIconService } from 'ng-zorro-antd';
/**
 * fc-iconå¾æ 
 * 
 * è¯­ä¹åçç¢éå¾å½¢ã
 * 
 * æä»¬ä¸ºæ¯ä¸ªå¾æ èµäºäºè¯­ä¹åçå½åï¼å½åè§åå¦ä¸:
 * 
 * å®å¿åæçº¿å¾æ ä¿æååï¼ç¨-oæ¥åºåï¼æ¯å¦Â question-circleï¼å®å¿ï¼åÂ question-circle-oï¼æçº¿ï¼ã
 * 
 * å½åé¡ºåºï¼[å¾æ å]-[å½¢ç¶?]-[æçº¿?]-[æ¹å?]ã
 * 
 */
@Component({
    selector: 'fc-icon',
    template: `
    <i class="iconfont" *ngIf="fcToolTip===undefined&&fcSvg===undefined" nz-icon [iconfont]="fcIcon" 
        [style.color]="fcColor" [style.fontSize]="fcFontSize"
        [ngClass]="{'fc-icon-small':fcSize === 'small','fc-icon-default':fcSize === 'default','fc-icon-large':fcSize === 'large'}"></i>
    <nz-tooltip  *ngIf="fcToolTip!==undefined&&fcSvg===undefined"
        [nzTitle]="fcToolTip" [nzPlacement]="fcPosition">
        <span nz-tooltip>
            <i [iconfont]="fcIcon"
            [style.color]="fcColor" nz-icon
            [ngClass]="{'fc-icon-small':fcSize === 'small','fc-icon-default':fcSize === 'default','fc-icon-large':fcSize === 'large'}" ></i>
        </span>
    </nz-tooltip>
    <i *ngIf="fcToolTip!==undefined&&fcSvg!==undefined" nz-icon [iconfont]="fcIcon" 
        [style.color]="fcColor" [style.fontSize]="fcFontSize"
        [ngClass]="{'fc-icon-small':fcSize === 'small','fc-icon-default':fcSize === 'default','fc-icon-large':fcSize === 'large'}"></i>
    <nz-tooltip  *ngIf="fcToolTip!==undefined&&fcSvg!==undefined&&fcIcon===undefined"
        [nzTitle]="fcToolTip" [nzPlacement]="fcPosition">
        <span nz-tooltip>
        <i [type]="fcSvg"
        [style.color]="fcColor" nz-icon
        [ngClass]="{'fc-icon-small':fcSize === 'small','fc-icon-default':fcSize === 'default','fc-icon-large':fcSize === 'large'}" ></i>
        </span>
    </nz-tooltip>
    `,
    styles: [`
    .fc-icon-small{
        font-size:16px;
    }
    .fc-icon-default{
        font-size:20px;
    }
    .fc-icon-large{
        font-size:30px;
    }

    `]
})
export class FciconComponent extends FcComponent {
     /** æç¤ºæ é¢*/
    @Input()
    fcToolTip: string;
     /** å­ä½é¢è²*/
    @Input()
    fcColor: string;
     /** iconå¾æ */
    @Input()
    fcIcon: string;
     /**æ é¢ä½ç½®*/
    @Input()
    fcPosition: string;
     /**å­ä½å¤§å°*/
    @Input()
    fcFontSize:string;
     /**æ¯æSVG*/
    @Input()
    fcSvg: string;
     /**svgçå®½*/
    @Input()
    fcWidth: string;
     /**svgçé«*/
    @Input()
    fcHeight: string;
    constructor(public provider: ProvidersService) { 
        super(provider, 'fc-icon'); 
        if (this.fcPosition === undefined) {
            this.fcPosition = "top";
        }
       
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcWidth !== undefined) {
            this.fcWidth = this.fcWidth + 'px';
        }
        if (this.fcHeight !== undefined) {
            this.fcHeight = this.fcHeight + 'px';
        }

    }
}
